import { AxiosResponse } from 'axios';
import { endpoints } from '~/constants/endpoints';
import { FindHistory } from '~/domain/api';
import { APIError } from '~/domain/api/errors';
import FindShippingCompaniesParams from '~/domain/model/FindShippingCompaniesParams';
import { CreateShippingCompanyParams } from '~/domain/model/ShippingCompany/CreateShippingCompanyParams';
import { FavoriteShippingCompany } from '~/domain/model/ShippingCompany/FavoriteShippingCompany';

import api from '../api';

export type FindMany = {
  siteId: number;
  pageNumber?: number;
  pageSize?: number;
};

export const findMany = async ({
  PageNumber = 1,
  PageSize = 100,
  ...params
}: FindShippingCompaniesParams) => {
  try {
    let url = endpoints.shippingCompany.shippingCompany;
    const entries = Object.entries({ ...params });

    url += `?PageSize=${PageSize}&PageNumber=${PageNumber}`;
    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of entries) {
      url += `&Data.${key}=${value}`;
    }

    const response: AxiosResponse = await api.get(url);

    return response.data;
  } catch (error: any) {
    const { data: dataError } = error.response;
    const { Status: errorStatus } = dataError;

    if (typeof dataError === 'string') {
      throw new APIError(String(dataError));
    }

    if ([400, 500].includes(errorStatus)) {
      throw new APIError(String(dataError.Errors.Messages[0]));
    }

    const messageError =
      dataError && dataError.length > 0 ? dataError[0] : error.message;

    throw new APIError(String(messageError));
  }
};

export const findHistory = async (shippingCompanyId: number) => {
  const response = await api.get<void, AxiosResponse<FindHistory>>(
    `${endpoints.shippingCompany.history}${shippingCompanyId}`
  );
  return response.data;
};

export const deleteShippingCompany = async (shippingCompanyId: number) => {
  const response = await api.put<void, AxiosResponse<boolean>>(
    `${endpoints.shippingCompany.delete}${shippingCompanyId}`
  );
  return !!response.data;
};

export const favoriteShippingCompanyRequest = async (
  params: FavoriteShippingCompany
) => {
  const response = await api.put<void, AxiosResponse<boolean>>(
    `${endpoints.shippingCompany.favorite}/${params.siteId}/${params.shippingCompanyId}`
  );
  return response.data;
};

export const createShippingCompany = async (
  createShippingCompanyParams: CreateShippingCompanyParams
) => {
  const response = await api.put(
    endpoints.shippingCompany.shippingCompany,
    createShippingCompanyParams
  );
  return response.data;
};

export const editShippingCompany = async (
  editShippingCompanyParams: CreateShippingCompanyParams
) => {
  const response = await api.put(
    endpoints.shippingCompany.shippingCompany,
    editShippingCompanyParams
  );
  return response.data;
};
